import {Table, TableBody, TableCell, TableColumn, TableHeader, TableRow} from "@heroui/table";
import {useQuery} from "@tanstack/react-query";
import {createFileRoute} from '@tanstack/react-router'
import React from "react";
import Content from "../../../components/Content.tsx";
import Header from "../../../Header.tsx";
import services from "../../../services";
import queryKeys from "../../../utilities/queryKeys.ts";

export const Route = createFileRoute('/_app/master/audits')({
    component: RouteComponent,
})

function RouteComponent() {
    const auditsQuery = useQuery<any[]>({
        queryKey: queryKeys.audits(),
        queryFn:  services.admin.audits,
    })

    const audits = (auditsQuery.data?.[0] ? auditsQuery.data : []).map((audit: any) => {
        if (typeof audit.old_values?.meta === 'string' && audit.old_values?.meta !== "[object Object]") {
            audit.old_values.meta = JSON.parse(audit.old_values.meta)
        }
        if (typeof audit.new_values?.meta === 'string' && audit.new_values?.meta !== "[object Object]") {
            audit.new_values.meta = JSON.parse(audit.new_values.meta)
        }
        delete audit.old_values?.version;
        delete audit.new_values?.version;
        return audit;
    });

    return (
        <div>
            <Header />

            <Content>
                <div className="mb-2 text-sm">
                    NOTE: Changes by Admin role users are not included.
                </div>
                <Table aria-label="Audits list" classNames={{wrapper: "p-1", th: "px-1 text-center", td: "px-1 py-1 text-center"}}
                       isVirtualized={true}
                       isStriped={true}
                       isHeaderSticky={true}>
                    <TableHeader>
                        <TableColumn>Name</TableColumn>
                        <TableColumn>From</TableColumn>
                        <TableColumn>To</TableColumn>
                    </TableHeader>
                    <TableBody>
                        {audits.map((audit: any) => (
                            <TableRow key={audit.uid}>
                                <TableCell className="text-left pl-2">
                                    <div>
                                        {audit.user?.name || 'NONAME'} ({audit.user?.email})<br />
                                        {audit.auditable_type?.replace(/.*\\/, '')}<br />
                                        {audit.created_at.replace(/\..*/, '')}
                                    </div>
                                </TableCell>
                                <TableCell className={"text-left whitespace-pre"}>{JSON.stringify(audit.old_values, null, 2)}<br /></TableCell>
                                <TableCell className={"text-left whitespace-pre"}>{JSON.stringify(audit.new_values, null, 2)}<br /></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                {auditsQuery.data?.length === 0 && (
                    <div>No users found.</div>
                )}

            </Content>

            {/*<pre>
                {JSON.stringify(auditsQuery.data?.[1], null, 2)}
            </pre>*/}
        </div>
    )
}
